import React from "react";

import { Button, Icon } from "@abb/abb-common-ux-react";
// @ts-ignore
import BootstrapTable from "react-bootstrap-table-next";
// @ts-ignore
import filterFactory from "react-bootstrap-table2-filter";
import IColumnHeaderData from "../../models/shared/ColumnHeaderData";
import { Translation } from "react-i18next";
import { DELETE, EDIT, LABEL_SEARCH_PROPERTY } from "../../utilities/Constants";

interface ITableValues {
  list: any[];
  columns: IColumnHeaderData[];
  name?: string;
  labelNumber?: number;
  select: boolean;
  isEditAction?: boolean;
  isDisableAction?: boolean;
  isEnableAction?: boolean;
  isDeleteAction?: boolean;
  isAssociation?: boolean;
  associationAction?: () => void;
  associationText?: string;
  noDataIndication?: string;
  selected?: any[];
  cellEdit?: any;
  handleOnSelect?: (row: any, isSelect: boolean) => void;
  handleOnSelectAll?: (isSelect: boolean, rows: any) => void;
  isEditable?: boolean;
  isTitle?: boolean;
  isPropertySearch?: boolean;
  propertySearchValue?: string;
  propertySearch?: (val: string) => void;
}

export default class TableComponent extends React.Component<ITableValues> {
  static defaultProps = {
    noDataIndication: "No Results Found",
    labelNumber: 1,
  };

  public render() {
    const selectRowHide = {
      mode: "checkbox",
      clickToSelect: true,
      clickToEdit: true,
      hideSelectColumn: true,
    };

    const selectRow = {
      mode: "checkbox",
      clickToSelect: true,
      selected: this.props.selected,
      onSelect: this.props.handleOnSelect,
      onSelectAll: this.props.handleOnSelectAll,
    };

    return (
      <Translation>
        {(t) => (
          <div
            className="mt-3 w-100 p-3 ml-1"
            style={{ background: "#F5F5F5" }}
          >
            {this.props.isTitle ? (
              <div className="ml-1">
                <p className="sidebar-main-title font-weight-bold ml-2">
                  {t(this.props.name)}
                </p>
              </div>
            ) : (
              <div className="float-left ml-3">
                <div className="box-circle">
                  <p className="box-circle-text"> {this.props.labelNumber} </p>
                </div>
                <div className="ml-4">
                  <p className="sidebar-main-title font-weight-bold ml-2">
                    {t(this.props.name)}
                  </p>
                </div>
              </div>
            )}

            <div className="float-right">
              {this.props.isEditAction ? (
                <Button
                  sizeClass="medium"
                  type="discreet-black"
                  shape={"pill"}
                  text={t(EDIT)}
                  icon={"abb/edit"}
                />
              ) : null}
              {this.props.isDeleteAction ? (
                <Button
                  sizeClass="medium"
                  type="discreet-black"
                  shape={"pill"}
                  text={t(DELETE)}
                  icon={"abb/trash"}
                />
              ) : null}
              {this.props.isAssociation ? (
                <Button
                  sizeClass="medium"
                  type="discreet-blue"
                  text={t(this.props.associationText)}
                  icon={"abb/plus"}
                  onClick={this.props.associationAction}
                />
              ) : null}
            </div>
            <div className="clearfix" />

            <div id={this.props.isPropertySearch ? "assoc-propertysearch" : ""}>
              {this.props.isPropertySearch ? (
                <div className="ml-3">
                  <div className="position-relative">
                    <button title="Search" className="searchIcon icon-button">
                      <Icon name="abb/search" sizeClass="small" />
                    </button>
                    <input
                      type="text"
                      className="searchInput"
                      placeholder={t(LABEL_SEARCH_PROPERTY)}
                      value={this.props.propertySearchValue}
                      onChange={(e) =>
                        this.props.propertySearch(e.target.value)
                      }
                    />
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>

            <hr className="hr-line ml-3" />
            {this.props.isEditable ? (
              <div className="ml-3">
                <BootstrapTable
                  keyField="id"
                  data={this.props.list}
                  columns={this.props.columns}
                  filter={filterFactory()}
                  filterPosition="top"
                  cellEdit={this.props.cellEdit}
                  rowClasses="table-lms-row"
                  classes={"edit-table"}
                  bootstrap4={true}
                  bordered={false}
                  noDataIndication={t(this.props.noDataIndication)}
                />
              </div>
            ) : (
              <div className="ml-3">
                <BootstrapTable
                  keyField="id"
                  data={this.props.list}
                  columns={this.props.columns}
                  filter={filterFactory()}
                  filterPosition="top"
                  selectRow={this.props.select ? selectRow : selectRowHide}
                  rowClasses="table-lms-row"
                  classes={
                    this.props.select
                      ? "table-lms "
                      : "table-lms table-lms-childStyle"
                  }
                  bootstrap4={true}
                  bordered={false}
                  noDataIndication={t(this.props.noDataIndication)}
                />
              </div>
            )}
          </div>
        )}
      </Translation>
    );
  }
}
